import * as yup from 'yup';

type FileInputValue = File | { id: number; url: string };

export const editHomeTileFormSchema = yup.object({
  name: yup.string().required('Название обязательно'),
  image: yup.mixed<FileInputValue>().optional().nullable(),
});

